import React, { createContext, useContext, useEffect, useState } from "react";
import { Layout, Grid } from "antd";
import style from "./superadmin-layout.module.scss";
import { Content } from "antd/es/layout/layout";
import { InviteModalProvider } from "@components/ModalContext/InviteModalContext";
import SuperAdminRouting from "../../../superadmin-roter-service";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "@stores/root-store";
import { constRoute } from "@utils/route";
import { onMasterLogOutClearAll } from "@utils/common-functions";
import MasterAdminHeader from "@components/common-components/MasterHeader/MasterAdminHeader";
import SidebarDrawer from "./sidebardrawer/SidebarDrawer";
import AdminHeader from "../admin-layout/header/AdminHeader";
import SideBar from "./sideBar/SideBar";

const { useBreakpoint } = Grid;

const UserContext = createContext(null);
const CartDataContext = createContext(null);

const SuperAdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get("email");

  const [userDetails, setUserDetails] = useState(null);
  const [cardData, setCardData] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);

  const screens = useBreakpoint();

  const {
    user: {
      getUserDetails,
      loadMasterAdminInfo,
      receiveAllUsers,
      handleGetDashboardData,
    },
  } = useStore(null);

  useEffect(() => {
    (async () => {
      const user = await loadMasterAdminInfo();
      if (user?.status === 401) {
        onMasterLogOutClearAll(constRoute.masteradminLogin);
      }
    })();
  }, []);

  const updateUserDetails = async () => {
    if (email) {
      const userData = await getUserDetails({ email });
      setUserDetails(userData);
    }
  };

  useEffect(() => {
    updateUserDetails();
  }, [email]);

  useEffect(() => {
    (async () => {
      await receiveAllUsers();
      const dashboardData = await handleGetDashboardData();
      setCardData(dashboardData);
    })();
  }, []);

  return (
    <UserContext.Provider value={{ userDetails, updateUserDetails }}>
      <CartDataContext.Provider value={cardData}>
        <Layout>
          <div
            style={{
              zIndex: 1000,
              position: "fixed",
              top: 0,
              left: 0, // start from very left
              right: 0, // go full width
              height: 64,
            }}
          >
            <MasterAdminHeader />
          </div>

          <div style={{ zIndex: 0 }}>
            <SidebarDrawer open={screens.lg ? true : true} onClose={() => {}} />
            {/* <SideBar /> */}
          </div>

          <InviteModalProvider>
            <Content
              style={{
                marginLeft: screens.lg ? 250 : 0,
                padding: 16,
                marginTop: 24, // same as header height
              }}
            >
              <SuperAdminRouting />
            </Content>
          </InviteModalProvider>
        </Layout>
      </CartDataContext.Provider>
    </UserContext.Provider>
    // <UserContext.Provider value={{ userDetails, updateUserDetails }}>
    //   <CartDataContext.Provider value={cardData}>
    //     <Layout className={style.layout}>
    //       <InviteModalProvider>
    //         <div className={style.layoutHeader}>
    //           <AdminHeader />
    //         </div>

    //         <div className={style.layoutSidebar}>
    //           <SideBar />
    //         </div>

    //         <Content>
    //           <SuperAdminRouting />
    //         </Content>
    //       </InviteModalProvider>
    //     </Layout>
    //   </CartDataContext.Provider>
    // </UserContext.Provider>
  );
};

export function useUserContext() {
  return useContext(UserContext);
}

export function useCartDataContext() {
  return useContext(CartDataContext);
}

export default SuperAdminLayout;
